// src/pages/LoginPage.jsx
import React, { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { useLocation, useNavigate, Link } from "react-router-dom";

export default function LoginPage() {
  const { login } = useAuth();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from?.pathname || "/admin/products";

  const onSubmit = (e) => {
    e.preventDefault();
    setErr("");
    if (login(u.trim(), p)) {
      nav(from, { replace: true });
    } else {
      setErr("Invalid username or password");
    }
  };

  // Header is fixed (h-16 + h-14 = 120px). We reserve that space then center.
  return (
    <main className="pt-[120px]">
      <div className="min-h-[calc(100vh-120px)] grid place-items-center px-4 py-8">
        <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm">
          <div className="mb-4 text-center">
            <h1 className="text-2xl font-semibold">Admin Login</h1>
            <p className="mt-1 text-sm text-slate-600">
              Use your admin credentials to continue
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium">Username</label>
              <input
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-[15px] focus:outline-none focus:ring-2 focus:ring-black/70"
                value={u}
                onChange={(e) => setU(e.target.value)}
                placeholder="e.g., admin"
                autoComplete="username"
                autoFocus
              />
            </div>

            <div>
              <label className="text-sm font-medium">Password</label>
              <div className="mt-1 relative">
                <input
                  type={show ? "text" : "password"}
                  className="w-full rounded-lg border border-slate-300 px-3 py-2 pr-16 text-[15px] focus:outline-none focus:ring-2 focus:ring-black/70"
                  value={p}
                  onChange={(e) => setP(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-2 my-auto text-sm text-slate-600 hover:text-black"
                  onClick={() => setShow((s) => !s)}
                  aria-label={show ? "Hide password" : "Show password"}
                >
                  {show ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {err && (
              <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                {err}
              </div>
            )}

            <button
              className="w-full rounded-lg bg-black text-white py-2.5 text-[15px] font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-black/70"
              type="submit"
            >
              Login
            </button>

            <div className="text-center text-sm">
              <Link to="/" className="underline">
                Back to shop
              </Link>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}
